import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import UserService from '../services/user.service';
import PropTypes from 'prop-types';

const DeleteUserButton = ({ userId, onSuccess, userName }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState(null);
    
    const handleDelete = async () => {
        // Mostra una conferma prima di procedere
        const confirmed = window.confirm(
            `Sei sicuro di voler eliminare definitivamente l'utente ${userName || userId}? 
            Questa azione è irreversibile e cancellerà tutti i dati associati.`
        );
        
        if (!confirmed) return;
        
        try {
            setIsDeleting(true);
            setError(null);
            
            await UserService.deleteUser(userId);
            
            // Notifica il componente padre del successo
            if (onSuccess) onSuccess();
            
        } catch (err) {
            console.error('Errore durante l\'eliminazione:', err);
            setError(err.message || 'Si è verificato un errore durante l\'eliminazione');
        } finally {
            setIsDeleting(false);
        }
    };
    
    return (
        <div>
            <button
                onClick={handleDelete}
                disabled={isDeleting}
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 flex items-center disabled:opacity-50"
            >
                <Trash2 className="w-4 h-4 mr-2" />
                {isDeleting ? 'Eliminazione in corso...' : 'Elimina utente'}
            </button>
            
            {error && (
                <div className="mt-2 text-red-600 text-sm">
                    {error}
                </div>
            )}
        </div>
    );
};

DeleteUserButton.propTypes = {
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onSuccess: PropTypes.func,
    userName: PropTypes.string
};

export default DeleteUserButton;